import { avatarColorFor, type AvatarColor } from '@cyphex/types/common';

/**
 * Solid colors used for team/person avatar tiles when there is no photo.
 *
 * AN ALIAS, NOT A SECOND LIST. This was a hand-maintained copy of `AvatarColor`
 * and a hand-maintained copy of its hash, in a package the API cannot import -
 * so the server had no way to agree with it and stamped `'#F97316'` on every
 * team instead. One palette, one hash, both trees.
 */
export type TeamColor = AvatarColor;

export const TEAM_COLOR_CLASS: Record<TeamColor, string> = {
  teal: 'bg-team-teal text-white',
  pink: 'bg-team-pink text-white',
  blue: 'bg-team-blue text-white',
  orange: 'bg-team-orange text-white',
  green: 'bg-team-green text-white',
  indigo: 'bg-team-indigo text-white',
  violet: 'bg-team-violet text-white',
  rose: 'bg-team-rose text-white',
  amber: 'bg-team-amber text-white',
  cyan: 'bg-team-cyan text-white',
  slate: 'bg-team-slate text-white',
};

/** Deterministic color for an id/name so the same team is always the same color. */
export const teamColorFor = avatarColorFor;

/** Up to two uppercase initials, e.g. "Product Design" → "PD". */
export function initialsFor(name: string): string {
  /* Only words that start with a letter or digit count: a suffix such as
     "(You)" or "- Guest" is not part of anybody's name. */
  const all = name.trim().split(/\s+/).filter(Boolean);
  const named = all.filter((word) => /^[\p{L}\p{N}]/u.test(word));
  const words = named.length > 0 ? named : all;
  if (words.length === 0) return '?';
  if (words.length === 1) return (words[0] ?? '').slice(0, 2).toUpperCase();
  return `${words[0]?.[0] ?? ''}${words[words.length - 1]?.[0] ?? ''}`.toUpperCase();
}
